// eslint-disable
import PARSE from "html-react-parser";
import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import store from "../../context/store";
import ApiNew from "./Api";
import { Helmet } from "react-helmet";

const api = new ApiNew();

export default function TBS_Hero() {
  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  const [sections, setSections] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [background, setBackground] = useState("");
  const [backgroundSmall, setBackgroundSmall] = useState("");
  const [boxContent, setBoxContent] = useState(null);

  const [listButton, setListButton] = useState(null);
  const [highlight, setHighLight] = useState([]);

  useEffect(() => {
    const getSectionDetail = () => {
      api
        .getSectionDetail({ language: activeLanguage })
        .then((res) => {
          if (res === 200 || res.data) {
            setSections(res.data.results);
          }
        })
        .catch((err) => {
          console.log("~ err", err);
        });
    };

    getSectionDetail();
  }, [activeLanguage]);

  useEffect(() => {
    let switchCaseCompleted = 0;

    if (sections.length > 0) {
      const sec = sections[0]?.widgets;
      if (sec && sec.length !== 0) {
        sec.forEach((section, i) => {
          switch (i) {
            case 0: {
              setBackground(
                section?.widget_contents[0]?.file ||
                  section?.widget_contents[0]?.file
              );
              console.log(
                "🚀 ~ file: SSoft_Hero.jsx:51 ~ sec.forEach ~ section?.widget_contents[0]:",
                section?.widget_contents[0]
              );
              setBackgroundSmall(
                section?.widget_contents[0]?.asset_mobile ||
                  section?.widget_contents[0]?.file
              );
              break;
            }
            case 1: {
              setBoxContent(section?.widget_contents[0]);
              break;
            }
            case 2: {
              setListButton(section?.widget_contents);
              break;
            }
            case 3: {
              setHighLight(section?.widget_contents[0]);
              break;
            }
            default:
              break;
          }

          switchCaseCompleted++; // Increment the switch case completion counter
        });

        if (switchCaseCompleted === 4) {
          setLoaded(true); // Set loaded to true after all switch cases have completed
        }
      }
    }
  }, [sections]);

  return loaded ? (
    <>
      <Helmet>
        {/* ==== BASIC SEO ==== */}
        <title>
          PT Supersoft Sistemindo | Infor & Hexagon License & Implementation
          Partner Indonesia
        </title>
        <meta
          name="description"
          content="PT Supersoft Sistemindo adalah partner resmi Infor & Hexagon di Indonesia yang menyediakan lisensi dan implementasi Infor SunSystems, Infor EPM, Infor XM, dan Hexagon EAM untuk transformasi digital perusahaan Anda."
        />
        <meta
          name="keywords"
          content="Infor SunSystems, Infor EPM, Infor XM, Hexagon EAM, implementasi ERP Indonesia, partner Infor Indonesia, lisensi Infor, implementasi Hexagon, enterprise asset management, enterprise performance management, expense management, PT Supersoft Sistemindo"
        />
        <link rel="canonical" href="https://ptsupersoft.com/" />

        {/* ==== OPEN GRAPH (Facebook, LinkedIn) ==== */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ptsupersoft.com/" />
        <meta
          property="og:title"
          content="PT Supersoft Sistemindo | Resmi Partner Lisensi & Implementasi Infor & Hexagon di Indonesia"
        />
        <meta
          property="og:description"
          content="Solusi lengkap untuk perusahaan di Indonesia melalui lisensi dan implementasi Infor SunSystems, Infor EPM, Infor XM, dan Hexagon EAM. Tingkatkan efisiensi operasional bersama Supersoft."
        />
        <meta
          property="og:image"
          content="https://bzpublishassets.blob.core.windows.net/media/assets/Illustration_1_mwNFaE6.png"
        />
        <meta property="og:site_name" content="PT Supersoft Sistemindo" />

        {/* ==== TWITTER CARD ==== */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="PT Supersoft Sistemindo | Resmi Partner Lisensi & Implementasi Infor & Hexagon di Indonesia"
        />
        <meta
          name="twitter:description"
          content="Supersoft menyediakan lisensi dan implementasi Infor SunSystems, Infor EPM, Infor XM, dan Hexagon EAM di Indonesia."
        />
        <meta
          name="twitter:image"
          content="https://bzpublishassets.blob.core.windows.net/media/assets/Illustration_1_mwNFaE6.png"
        />
        <meta name="twitter:site" content="@ptsupersoft" />

        {/* ==== STRUCTURED DATA / SCHEMA.ORG ==== */}
        <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "PT Supersoft Sistemindo",
        "url": "https://ptsupersoft.com",
        "logo": "https://bzpublishassets.blob.core.windows.net/media/assets/logo_YIA5XFd.png",
        "sameAs": [
          "https://www.linkedin.com/company/ptsupersoft/",
          "https://x.com/ptsupersoft"
        ],
        "description": "PT Supersoft Sistemindo adalah partner resmi Infor & Hexagon di Indonesia yang menyediakan lisensi dan implementasi Infor SunSystems, Infor EPM, Infor XM, dan Hexagon EAM.",
        "foundingDate": "1991",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "ID",
          "addressLocality": "Jakarta",
          "addressRegion": "Indonesia"
        },
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+62 21 3973 8310",
          "contactType": "Customer Support",
          "areaServed": "ID"
        },
        "knowsAbout": [
          "Infor SunSystems",
          "Infor EPM",
          "Infor XM",
          "Hexagon EAM",
          "Enterprise Asset Management",
          "Enterprise Performance Management",
          "Expense Management",
          "ERP Implementation Indonesia"
        ],
        "offers": [
          {
            "@type": "Service",
            "name": "Infor SunSystems License & Implementation",
            "serviceType": "Financial Management Solution"
          },
          {
            "@type": "Service",
            "name": "Infor EPM Implementation",
            "serviceType": "Enterprise Performance Management"
          },
          {
            "@type": "Service",
            "name": "Infor XM Implementation",
            "serviceType": "Expense Management"
          },
          {
            "@type": "Service",
            "name": "Hexagon EAM License & Implementation",
            "serviceType": "Enterprise Asset Management"
          }
        ]
      }
      `}</script>

        {/* ==== FAQ SCHEMA ==== */}
        <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Apa itu PT Supersoft Sistemindo?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "PT Supersoft Sistemindo adalah partner resmi Infor & Hexagon di Indonesia yang menyediakan lisensi dan implementasi untuk solusi Infor SunSystems, Infor EPM, Infor XM, dan Hexagon EAM. Kami membantu perusahaan melakukan transformasi digital melalui solusi keuangan, aset, performa, dan pengeluaran yang terintegrasi."
            }
          },
          {
            "@type": "Question",
            "name": "What is PT Supersoft Sistemindo?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "PT Supersoft Sistemindo is an official Infor and Hexagon partner in Indonesia, providing software licensing and implementation for Infor SunSystems, Infor EPM, Infor XM, and Hexagon EAM. We help organizations digitally transform through integrated financial, asset, performance, and expense management solutions."
            }
          },
          {
            "@type": "Question",
            "name": "Apakah PT Supersoft menjual lisensi Infor dan Hexagon?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ya, PT Supersoft Sistemindo menyediakan lisensi resmi dan layanan implementasi untuk solusi Infor SunSystems, Infor EPM, Infor XM, serta Hexagon EAM di Indonesia. Kami juga mendukung perusahaan dalam proses deployment, integrasi, dan pelatihan pengguna."
            }
          },
          {
            "@type": "Question",
            "name": "Does PT Supersoft sell Infor and Hexagon software licenses?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, PT Supersoft Sistemindo is a licensed distributor and implementation partner for Infor SunSystems, Infor EPM, Infor XM, and Hexagon EAM in Indonesia, offering end-to-end services from licensing to deployment and user training."
            }
          },
          {
            "@type": "Question",
            "name": "Apa saja solusi yang ditawarkan PT Supersoft Sistemindo?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Solusi utama kami mencakup: Infor SunSystems (Financial Management), Infor EPM (Enterprise Performance Management), Infor XM (Expense Management), dan Hexagon EAM (Enterprise Asset Management). Semua solusi ini dirancang untuk meningkatkan efisiensi, transparansi, dan produktivitas bisnis."
            }
          },
          {
            "@type": "Question",
            "name": "What solutions does PT Supersoft Sistemindo offer?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We offer comprehensive business software solutions: Infor SunSystems for Financial Management, Infor EPM for Enterprise Performance Management, Infor XM for Expense Management, and Hexagon EAM for Enterprise Asset Management — empowering your business to operate more efficiently and intelligently."
            }
          },
          {
            "@type": "Question",
            "name": "Apakah Supersoft memberikan pelatihan dan dukungan setelah implementasi?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Ya, Supersoft menyediakan pelatihan (training) dan dukungan teknis pasca implementasi, termasuk pembaruan sistem, maintenance, dan bantuan optimalisasi untuk memastikan solusi berjalan sesuai kebutuhan bisnis Anda."
            }
          },
          {
            "@type": "Question",
            "name": "Does Supersoft provide training and post-implementation support?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, Supersoft offers post-implementation support, maintenance, and training to ensure smooth system operation and maximum return on investment for every Infor and Hexagon solution deployed."
            }
          },
          {
            "@type": "Question",
            "name": "Bagaimana cara menghubungi PT Supersoft Sistemindo?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Anda dapat menghubungi kami melalui halaman Contact di situs resmi https://ptsupersoft.com atau melalui telepon di +62 21 3973 8310. Tim kami siap membantu Anda memilih dan mengimplementasikan solusi terbaik untuk bisnis Anda."
            }
          },
          {
            "@type": "Question",
            "name": "How can I contact PT Supersoft Sistemindo?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "You can contact us via the Contact page at https://ptsupersoft.com or by phone at +62 21 3973 8310. Our team will assist you in selecting and implementing the right Infor and Hexagon solutions for your organization."
            }
          }
        ]
      }
      `}</script>

        {/* ==== AI SEARCH OPTIMIZATION ==== */}
        <meta
          name="ai-keywords"
          content="Infor SunSystems license Indonesia, Hexagon EAM partner Indonesia, Infor EPM implementation, Infor XM consultant, enterprise software Indonesia, PT Supersoft Sistemindo AI optimized"
        />
        <meta
          name="ai-summary"
          content="PT Supersoft Sistemindo membantu perusahaan di Indonesia dengan lisensi dan implementasi resmi solusi Infor & Hexagon, mencakup Infor SunSystems, Infor EPM, Infor XM, dan Hexagon EAM."
        />
      </Helmet>
      <div className="pt-[250px] pb-[100px] bg-gradient-to-t from-[#FAF8F5] to-white">
        <div className="section-container section-margin-x">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            {/* Text Content */}
            <div className="lg:w-1/2 space-y-8">
              {" "}
              {/* ← Key: space-y-8 for consistent vertical rhythm */}
              <h1
                // className="text-[#0D4052] font-dmsans-bold font-[700] text-[32px] md:text-[42px] lg:text-[55px] xl:text-[64px] leading-[115%] max-w-[500px]"
                className="text-[#0D4052] font-dmsans-bold font-[700] text-[40px] leading-[115%] max-w-[500px]"
              >
                {boxContent?.article_language?.title}
              </h1>
              <h2
                // className="text-[#666] text-[18px] md:text-[22px] leading-[115%] font-inter max-w-[500px]"
                className="text-[#666] text-[18px] leading-[115%] font-inter max-w-[500px]"
              >
                {PARSE(boxContent?.article_language?.content)}
              </h2>
              <div className="flex flex-col sm:flex-row gap-4 pt-4">
                {" "}
                {/* ← Smaller gap after text */}
                <Link
                  to={listButton[0]?.article_language?.path || "/"}
                  onClick={() =>
                    store.dispatch({
                      type: "topicStore/setTopicValue",
                      payload: "General",
                    })
                  }
                  className="inline-block"
                >
                  <div className="bg-[#E12726] text-white font-semibold px-6 py-3 rounded-[8px] text-[12px] sm:text-[16px] md:text-[22px]">
                    {listButton[0]?.article_language.title}
                  </div>
                </Link>
                {listButton.length > 1 && (
                  <Link
                    to={listButton[1]?.article_language?.path || "/"}
                    className="inline-block"
                  >
                    <div className="bg-[#0D4052] text-white font-semibold px-6 py-3 rounded-[8px] text-[12px] sm:text-[16px] md:text-[22px]">
                      {listButton[1]?.article_language.title}
                    </div>
                  </Link>
                )}
              </div>
              {/* Footer Text — smaller space below buttons */}
              <p className="text-[#999] text-[12px] md:text-[14px] mt-6 prose-img:h-6 flex prose-p:!w-full prose-p:!flex prose-img:mx-1">
                {PARSE(highlight?.article_language?.content || "")}
              </p>
            </div>

            {/* Image Section */}
            <div className="lg:w-1/2 flex justify-center">
              <picture className="w-full max-w-[550px] rounded-xl overflow-hidden shadow-lg">
                <source media="(max-width: 576px)" srcSet={backgroundSmall} />
                <img
                  src={background}
                  alt={boxContent?.article_language?.title}
                  className="w-full h-auto object-cover"
                  fetchpriority="high"
                />
              </picture>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <Skeleton
      width={"100%"}
      className="!z-[100] qhd:!h-[calc(60vh+78px)] md:!h-[calc(585px+78px)] h-[calc(60vh+78px)]"
    />
  );
}
